angular.module("annexes")

    .controller('AnnexesListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state) {

        $rootScope.title = $filter('translate')('annexes.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('annexes.subtitleList') }
        ];

        $scope.gridOptionsAnnexes = {
            pdfTitle: $filter('translate')('annexes.pdf_title'),
            exporterMenuCsv: true,
            exporterCsvColumnSeparator: ';',  
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: 100,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'FK_events_programs_annexes_types_tl_events_programs_annexes_types[0].name', displayName: $filter('translate')('annexes.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'annex_order', displayName: $filter('translate')('annexes.order'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                { name: 'is_default', displayName: $filter('translate')('annexes.is_default'), enableFiltering: true, cellTemplate: '<i ng-if="row.entity.is_default > 0" class="fa fa-circle" style="color:green"></i><i ng-if="row.entity.is_default == 0" class="fa fa-circle" style="color:gray"></i>' },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ui-sref="annexes.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.FK_events_programs_annexes_types_tl_events_programs_annexes_types[0].name);"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },

            ],
            getData: function (options) {

                return Restangular.all('AnnexesTypes').getList(options);
            }

        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("annexes.edit", { id: rowEntity.id });
        }

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('general.button_delete'),
                message: $filter('translate')('general.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('AnnexesTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('general.delete_success'));
                        $scope.gridOptionsAnnexes.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };


    }])

    ;